<i18n>
{
	"en": {
		"add": "Added",
		"remove": "Removed",
		"orderType": "Order Type",
		"name": "Name",
		"code": "Code",
		"alternativeName": "Alternative Name",
		"tripHandling": "Has trip handling"
	},
	"no": {
		"add": "Laget",
		"remove": "Slettet",
		"orderType": "Oppdragstype",
		"name": "Navn",
		"code": "Kode",
		"alternativeName": "Alternativt navn",
		"tripHandling": "Has trip handling"
	}
}
</i18n>
<template>
	<t-vertical-panel>
		<div slot="header" class="details-header">
			<t-panel-header icon="undefined" :text="$t('orderType')"/>
			<div class="details-header-sub-label" v-text="$t(op)"/>
			<t-icon-button
				style="margin-right: 10px;"
				appearance="minimal"
				type="bp"
				icon="cross"
				iconSize="md"
				@click="$emit('close')"
			/>
		</div>
		<div class="content">
			<t-pane v-bind="paneOptions">
				<div class="content-data">
					<TLabeledValue
						:label="$t('name')"
						:value="data.name"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('code')"
						:value="data.code"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('alternativeName')"
						:value="data.alternativeName"
						labelMarginBottom="5px"
					/>

					<t-checkbox
						:label="$t('tripHandling')"
						:checked="data.tripHandling"
						disabled
					/>
				</div>
			</t-pane>
		</div>
	</t-vertical-panel>
</template>

<script>
export default {
	name: 'OrderType',
	props: {
		data: Object,
		op: String
	},
	data() {
		return {
			paneOptions: {
				border: 'default',
				background: 'tint1',
				borderRadius: '5px',
				style: { padding: '5px', }
			},
		};
	}
};
</script>
<style lang="scss" scoped>
.content {
	margin: 10px;
}
.content-data {
	display: grid;
	grid-template-columns: minmax(150px, 1fr);
	column-gap: 20px;
	row-gap: 20px;
}
.details-header {
	height: 100%;
	display:flex;
	align-items: center;
	padding-left: 5px;
	.details-header-sub-label {
		flex: 1;
		color: #66788a;
		font-size: 14px;
	}
}
</style>